<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("machinemente.title_edit") }}</h1>
    <form>
      <b-card :title="this.$i18n.t('machinemente.label_edit')" class="w-50">
            <b-form-group
              id="machineId"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('machinemente.label_machine_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="machineId" disabled></b-form-input>
            </b-form-group>
            <b-form-group
              id="machineName"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('machinemente.label_machine_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="machineName" :placeholder="this.$i18n.t('machinemente.placeholder_machine_name')" maxlength="40"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="back" class="float-left px-5">{{ $i18n.t("machinemente.label_back") }}</b-button>
            </div>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("machinemente.button_update") }}</b-button>
            </div>
      </b-card>
    </form>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('machinemente.info_update')" :titleMsg="this.$i18n.t('machinemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      machineId: null,
      machineName: null,
      searchMachineId: null,
      searchMachineName: null,
      efFlg: true,
      currentPage: 1,
      perPage: 5,
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      errMsg: '',
      errSbj: ''
    }
  },
  methods: {
    regist: function () {
      // 入力値チェック
      if (this.machineId === null || this.machineId === '') {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_id_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (this.machineName === null || this.machineName === '') {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.machineName)) {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_name_symbol')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.machineId = this.machineId.toString()
      reqObj.machineName = this.machineName

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/update', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    back: function () {
      var searchFlg = 1
      var path = '/machinemente'
      this.$router.push({ path: path, query: {searchFlg: [searchFlg], searchMachineId: [this.searchMachineId], searchMachineName: [this.searchMachineName]} })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    body.machineId = this.$store.store.state.editid
    body.machineIdLikeFlg = '0'
    body.machineName = ''
    body.efFlg = ''

    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/master/machine/select', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        } else {
          var machineInfoList = res.data.machineInfo

          // 整形
          this.machineId = machineInfoList[0].machine_id
          this.machineName = machineInfoList[0].machine_name
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        alert(res)
        console.log(res)
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err')
      })
    console.log(this.from)

    // 検索条件セット
    this.searchMachineId = this.$store.store.state.searchMachineId
    this.searchMachineName = this.$store.store.state.searchMachineName
  },
  routes: [
    {
      path: '/machinemente/:searchFlg/:searchMachineId/:searchMachineName',
      name: 'machinemente',
      components: './Machinemente.vue'
    }
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MachinementeEdit.vue